// Shared fallback keeps editor, preview, and details rendering aligned.
export const DEFAULT_PRINTOUT_FONT_FAMILY = 'system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';

export const getPrintoutFontFamily = (fontFamily?: string) => {
    const family = fontFamily?.trim();

    return family || DEFAULT_PRINTOUT_FONT_FAMILY;
};

export const getPrintoutFontSx = (fontFamily?: string, headingFontFamily?: unknown) => ({
    fontFamily: getPrintoutFontFamily(fontFamily),
    "--printout-heading-font-family": typeof headingFontFamily === "string" && headingFontFamily.trim()
        ? headingFontFamily.trim()
        : getPrintoutFontFamily(fontFamily),
});
